module.exports = __webpack_public_path__ + "55b57d7de05bd719ad76554298c61264.pdf";